/* ==========================================================================
   APEX product page behaviour (template suffix "apex")
   - Purchase option cards -> hidden selling_plan input inside the theme's product form
   - Button, price and sticky-bar labels always state the commitment
   - Read-more fold on mobile
   - Free-shipping bar reads the real cart via /cart.js and refreshes on cart change
   - Gallery: the stack video is taken out of the rotation
   - Stack video: muted preview loop while on screen; play button restarts from the start with sound
   - Stack carousel arrows (desktop)
   Built 2026-09-07. Companion: assets/apex-pdp.css
   ========================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Purchase options ---------- */
  function initOptions() {
    var box = document.querySelector('[data-apex-options]');
    if (!box) return;
    var formId = box.getAttribute('data-form-id');
    var form = document.getElementById(formId) || document.querySelector('.section-main-product .js-product-form');
    if (!form) return;

    var oncePrice = box.getAttribute('data-once-price');
    var subPrice = box.getAttribute('data-sub-price');
    var planId = box.getAttribute('data-plan-id');
    var priceEl = document.querySelector('.section-main-product .product-info__price');
    var priceOriginal = priceEl ? priceEl.innerHTML : null;
    var addBtn = form.querySelector('[name="add"]');

    var hidden = form.querySelector('input[name="selling_plan"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'selling_plan';
      hidden.value = '';
      hidden.disabled = true;
      form.appendChild(hidden);
    }

    function sticky() {
      return {
        variant: document.querySelector('[data-bnb-sticky-variant]'),
        text: document.querySelector('[data-bnb-sticky-button-text]')
      };
    }

    function apply(isSub) {
      document.body.classList.toggle('apex-plan-sub', isSub);
      if (isSub && planId) { hidden.value = planId; hidden.disabled = false; }
      else { hidden.value = ''; hidden.disabled = true; }

      if (addBtn) {
        addBtn.textContent = isSub ? 'Subscribe & Save · ' + subPrice + '/mo' : 'Add to cart · ' + oncePrice;
        addBtn.setAttribute('data-add-to-cart-text', addBtn.textContent);
      }
      if (priceEl && priceOriginal !== null) {
        priceEl.innerHTML = isSub
          ? '<span class="price__was">' + oncePrice + '</span> <span class="price__current">' + subPrice + '</span><span class="apex-per">/ month</span>'
          : priceOriginal;
      }
      var s = sticky();
      if (s.variant) s.variant.textContent = isSub ? subPrice + '/mo · Monthly subscription' : oncePrice + ' · One-time purchase';
      if (s.text) s.text.textContent = isSub ? 'Subscribe' : 'Add to cart';
      box.setAttribute('data-apex-plan', isSub ? 'sub' : 'once');
      // Loyalty points follow the selected option: one point per dollar, so the subscribe price earns fewer.
      var pts = document.querySelector('[data-apex-points]');
      if (pts) {
        var ptsN = pts.querySelector('[data-apex-points-n]');
        var v = isSub ? pts.getAttribute('data-sub') : pts.getAttribute('data-once');
        if (ptsN && v) ptsN.textContent = v;
      }
      // Selected-card highlight without :has() (older iOS Safari)
      box.querySelectorAll('.apex-opt').forEach(function (l) { var r = l.querySelector('input[name="apex_plan"]'); l.classList.toggle('is-selected', !!(r && r.checked)); });
    }

    box.querySelectorAll('input[name="apex_plan"]').forEach(function (r) {
      r.addEventListener('change', function () { apply(r.value !== 'once'); });
    });

    // The sticky bar rewrites its own label on variant/quantity events; re-apply ours after it does.
    document.addEventListener('on:variant:change', function () { setTimeout(function () { apply(box.getAttribute('data-apex-plan') === 'sub'); }, 50); });
    var qty = form.querySelector('input[name="quantity"]');
    if (qty) qty.addEventListener('change', function () { setTimeout(function () { apply(box.getAttribute('data-apex-plan') === 'sub'); }, 50); });

    var checked = box.querySelector('input[name="apex_plan"]:checked');
    apply(!!(checked && checked.value !== 'once'));
    // Late-arriving sticky bar (defer): re-apply once it exists
    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      if (sticky().text || tries > 20) { clearInterval(t); apply(box.getAttribute('data-apex-plan') === 'sub'); }
    }, 250);
  }

  /* ---------- Sticky bar gate ----------
     The shared bnb-sticky-atc shows whenever the main add-to-cart is outside the viewport, which is also
     true at the top of the page before the shopper has reached it. That puts a buy bar on screen before
     the price and the Subscribe & Save cards have been read. Here the bar stays down until the button has
     genuinely been scrolled past (its bottom above the viewport top); after that the shared script governs
     as normal. One-way latch, so it does not flicker on the way back up. */
  function initStickyGate() {
    // Re-query every time: the theme replaces the add-to-cart button on variant change, and a detached
    // node reports a zero rect, which would read as "never passed". Adnan's script re-points for the
    // same reason.
    function mainButton() {
      return document.querySelector('.section-main-product .quantity-submit-row .add-to-cart')
          || document.querySelector('.section-main-product button[name="add"]');
    }
    if (!mainButton()) return;
    function check() {
      var btn = mainButton();
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      if (!r.width && !r.height) return;   // detached or not laid out yet
      if (r.bottom >= 0) return;
      document.body.classList.add('apex-atc-passed');
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Read more (About block, mobile) ---------- */
  function initReadMore() {
    document.querySelectorAll('[data-apex-readmore]').forEach(function (btn) {
      var target = document.getElementById(btn.getAttribute('data-apex-readmore'));
      if (!target) return;
      btn.addEventListener('click', function () {
        var open = target.classList.toggle('is-open');
        btn.textContent = open ? 'Read less −' : 'Read more +';
      });
    });
  }

  /* ---------- Free-shipping bar (real cart) ---------- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function initShipBar() {
    var bar = document.querySelector('[data-apex-ship]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 15000;
    var maxCard = parseInt(bar.getAttribute('data-max-card'), 10) || 0;
    var minCard = parseInt(bar.getAttribute('data-min-card'), 10) || 0;
    var subOk = bar.getAttribute('data-sub-ok') || '';
    var msg = bar.querySelector('[data-apex-ship-msg]');
    var sub = bar.querySelector('[data-apex-ship-sub]');
    var amt = bar.querySelector('[data-apex-ship-amt]');
    var tot = bar.querySelector('[data-apex-ship-tot]');
    var fill = bar.querySelector('[data-apex-ship-fill]');
    var truck = bar.querySelector('[data-apex-ship-truck]');
    var thresholdLabel = money(threshold).replace('.00', '');

    // Three states: ok (threshold met), add (one card below covers the gap), far (fallback).
    function render(total) {
      var gap = threshold - total;
      var pct = Math.min(100, (total / threshold) * 100);
      var state = gap <= 0 ? 'ok' : (maxCard && gap <= maxCard ? 'add' : 'far');
      bar.classList.remove('is-ok', 'is-add', 'is-far');
      bar.classList.add('is-' + state);
      if (fill) fill.style.width = pct + '%';
      if (truck) truck.style.left = (state === 'ok' ? 100 : state === 'far' ? 0 : Math.max(4, Math.min(96, pct))) + '%';
      if (msg) msg.innerHTML = state === 'ok' ? '<em>Free shipping unlocked</em>'
        : state === 'add' ? 'Add one and <em>unlock free shipping</em>'
        : 'You’re <em>' + money(gap) + '</em> from free shipping';
      if (sub) sub.textContent = state === 'ok' ? subOk
        : state === 'add' ? (minCard && gap <= minCard ? 'Any product below gets you there.' : 'One more product gets you there.')
        : 'Free shipping on orders over ' + thresholdLabel + '.';
      if (amt) amt.innerHTML = state === 'add' ? money(gap) + '<span class="apex-ship__togo"> to go</span>' : money(total);
      if (tot) tot.textContent = state === 'add' ? money(total) + ' / ' + thresholdLabel : '/ ' + thresholdLabel;
    }
    var pending = null;
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price || 0); })
        .catch(function () {});
    }
    function schedule(delay) {
      clearTimeout(pending);
      pending = setTimeout(refresh, delay || 250);
    }

    render(parseInt(bar.getAttribute('data-cart-total'), 10) || 0);

    // 1. Theme events (main add-to-cart, sticky bar, theme cart drawer)
    ['on:cart:change', 'on:cart:add', 'on:cart:after-merge', 'on:cart-drawer:after-close'].forEach(function (name) {
      document.addEventListener(name, function () { schedule(300); });
    });

    // 2. Any script that talks to the cart directly (UpCart drawer removes/quantity changes, apps):
    //    watch fetch + XMLHttpRequest for /cart/add|change|update|clear and re-read the cart afterwards.
    var cartCall = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
    function isCartCall(url) { return cartCall.test(String(url || '')); }
    if (window.fetch && !window.fetch.__apexWrapped) {
      var origFetch = window.fetch;
      var wrapped = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = origFetch.apply(window, arguments);
        if (isCartCall(url)) p.then(function () { schedule(250); }, function () { schedule(250); });
        return p;
      };
      wrapped.__apexWrapped = true;
      window.fetch = wrapped;
    }
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__apexWrapped) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (isCartCall(url)) this.addEventListener('loadend', function () { schedule(250); });
        return origOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__apexWrapped = true;
    }

    // 3. Coming back to the page (back button, another tab): the server-rendered total may be stale.
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    refresh();
  }

  /* ---------- Stack cards: price follows the selected variant ---------- */
  function initStackCards() {
    document.querySelectorAll('.apex-card select[name="id"]').forEach(function (sel) {
      var form = sel.closest('form');
      var priceEl = form ? form.querySelector('[data-apex-price]') : null;
      function update() {
        var opt = sel.options[sel.selectedIndex];
        if (priceEl && opt && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
      }
      sel.addEventListener('change', update);
      update();
    });
  }

  /* ---------- Gallery: media shown elsewhere on the page is taken out of the rotation ----------
     window.apexGallery.hide = media ids (set by sections/apex-stack.liquid for its video). The theme's carousel
     skips [hidden] slides, so the slide and its thumbnail get the hidden attribute and every carousel is refreshed. */
  function initGallery() {
    var cfg = window.apexGallery || {};
    var gallery = document.querySelector('.section-main-product media-gallery');
    if (!gallery) return;
    var hide = (cfg.hide || []).map(String);
    if (!hide.length) return;
    var changed = false;
    gallery.querySelectorAll('.slider__item[data-media-id]').forEach(function (item) {
      if (hide.indexOf(String(item.getAttribute('data-media-id'))) > -1) { item.hidden = true; changed = true; }
    });
    if (!changed) return;
    gallery.querySelectorAll('carousel-slider').forEach(function (c) {
      if (typeof c.refresh === 'function') c.refresh();
    });
  }

  /* ---------- Stack video ----------
     Preview: muted loop while on screen, play button over it. Play: restart from 0 with sound (no loop);
     tap the video to pause / resume; ends -> back to the muted preview. Off screen -> paused. */
  function initStackVideo() {
    var box = document.querySelector('[data-apex-video]');
    if (!box) return;
    var video = box.querySelector('video');
    var playBtn = box.querySelector('[data-apex-play]');
    var soundBtn = box.querySelector('[data-apex-sound]');
    if (!video) return;
    var mode = 'preview';   // 'preview' | 'sound'
    var inView = false;
    var userPaused = false;

    function tryPlay() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    function setState() {
      box.classList.toggle('is-playing', mode === 'sound' && !video.paused);
      box.classList.toggle('is-paused', mode === 'sound' && video.paused);
      if (soundBtn) {
        soundBtn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
      }
    }
    function preview() {
      mode = 'preview';
      userPaused = false;
      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
      if (inView) tryPlay();
      setState();
    }
    function playWithSound() {
      mode = 'sound';
      userPaused = false;
      video.loop = false;
      video.muted = false;
      try { video.currentTime = 0; } catch (e) {}
      tryPlay();
      setState();
    }

    preview();

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) {
            video.preload = 'auto';
            if (mode === 'preview' || !userPaused) tryPlay();
          } else {
            video.pause();
          }
          setState();
        });
      }, { threshold: 0.3 }).observe(box);
    } else {
      inView = true;
      tryPlay();
    }

    // The theme pauses every <video> on the page whenever the gallery changes slide; resume the muted preview if it is on screen.
    video.addEventListener('pause', function () {
      setState();
      if (mode === 'preview' && inView) setTimeout(function () { if (mode === 'preview' && inView && video.paused) tryPlay(); }, 80);
    });
    video.addEventListener('play', setState);
    video.addEventListener('ended', preview);

    if (playBtn) {
      playBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (mode === 'sound' && video.paused) { userPaused = false; tryPlay(); }   // resume
        else playWithSound();                                                        // from the start
      });
    }
    if (soundBtn) {
      soundBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        video.muted = !video.muted;
        setState();
      });
    }
    // Tap the picture itself: pause while playing with sound, resume when paused; in preview mode start with sound.
    video.addEventListener('click', function () {
      if (mode === 'sound') {
        if (video.paused) { userPaused = false; tryPlay(); }
        else { userPaused = true; video.pause(); }
      } else {
        playWithSound();
      }
    });
  }

  /* ---------- Stack carousel arrows (desktop; on mobile the same list is vertical and the arrows are hidden) ---------- */
  function initStackCarousel() {
    var wrap = document.querySelector('.apex-stack__cards');
    if (!wrap) return;
    var track = wrap.querySelector('.apex-stack');
    var prev = wrap.querySelector('[data-apex-prev]');
    var next = wrap.querySelector('[data-apex-next]');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.apex-card');
      return card ? card.getBoundingClientRect().width + 18 : 300;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      wrap.classList.toggle('is-scrollable', max > 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }

  ready(function () {
    initGallery();
    initStackCarousel();
    initOptions();
    initStickyGate();
    initReadMore();
    initShipBar();
    initStackCards();
    initStackVideo();
  });
})();
